import { getRequestProfileWidgetColumns } from './RequestProfileWidgetListColumns.utils'

import * as styles from './RequestProfileWidgetListColumns.module.css'

function RequestProfileWidgetListColumns({ widgets }) {
  const [leftColumnWidgets, rightColumnWidgets] =
    getRequestProfileWidgetColumns(widgets)

  return (
    <div className={styles.twoColumns}>
      <div className={styles.column}>{leftColumnWidgets}</div>
      <div className={styles.column}>{rightColumnWidgets}</div>
    </div>
  )
}

export default RequestProfileWidgetListColumns
